var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotoficationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.737,
    cy: 23.6276,
    r: 22.737,
    fill: "#FFFFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4513 30.9355L20.6949 31.2603C21.7911 32.722 23.9836 32.722 25.0799 31.2603L25.3235 30.9355M16.5395 26.5096L16.6235 26.6826C17.1625 27.7938 18.289 28.4994 19.524 28.4994H26.1996C27.2579 28.4994 28.2429 27.9587 28.8111 27.0659C29.6132 25.8055 29.4008 24.1521 28.3061 23.1355L28.2705 23.1024C27.5272 22.4122 27.1613 21.4066 27.2871 20.4001L27.3396 19.9804C27.6365 17.605 25.7843 15.5068 23.3904 15.5068H22.0076C19.6166 15.5068 17.7667 17.6024 18.0632 19.9749L18.1277 20.4904C18.2464 21.4398 17.8996 22.3881 17.1964 23.0369C16.236 23.9232 15.9692 25.3338 16.5395 26.5096Z",
    stroke: "black",
    strokeWidth: 1.21805,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoficationIcon);
export default __webpack_public_path__ + "static/media/NotoficationIcon.3258cf346b5e24a5c7ff9f3bebab61c2.svg";
export { ForwardRef as ReactComponent };